import React, { useEffect, useRef, useState } from "react";
import { background, layout, position, space } from "styled-system";

import PropTypes from "prop-types";
import styled from "styled-components";

const BasePicture = styled.picture`
  ${space}
  ${layout}
  ${background}
  ${position}
`;

function Picture({ src, alt, sources, cover, ...props }) {
  const [loaded, setLoaded] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    if (imageRef.current && imageRef.current.complete) {
      setLoaded(true);
    }
  }, [imageRef]);

  return (
    <BasePicture {...props}>
      {sources.map((source, index) => {
        return (
          <source
            key={index}
            media={source.media}
            srcSet={source.srcset}
          ></source>
        );
      })}
      <img
        onLoad={() => {
          setLoaded(true);
        }}
        ref={imageRef}
        alt={alt}
        src={src}
        style={{
          transition: "opacity 500ms",
          opacity: loaded ? 1 : 0,
          objectFit: "cover",
          position: "absolute",
          height: "100%",
          width: "100%",
        }}
      ></img>
    </BasePicture>
  );
}

Picture.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      media: PropTypes.string.isRequired,
      srcSet: PropTypes.string.isRequired,
    })
  ),
};

export default Picture;
